import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, FacebookIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer data-component="COMP-02-Footer" className="bg-navy-900 text-white pt-20 pb-10" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-149">
          {/* Brand Col */}
          <div className="space-y-6" data-id="element-150">
            <Link to="/" className="inline-flex" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/x5wZymbCzDBTuYMxy9hThA/cropped-Bright-Star-Sports-Home-Page-01.png" alt="Bright Star Sports" className="h-12 w-auto" data-id="element-152" />
            </Link>
            <p className="text-navy-300 leading-relaxed" data-id="element-153">
              Olympian-led coaching for young champions. Building confidence,
              skills, and friendships through sport.
            </p>
            <div className="flex space-x-4" data-id="element-154">
              <a href="#" aria-label="Follow us on Instagram" className="w-10 h-10 rounded-full bg-navy-800 flex items-center justify-center text-navy-300 hover:bg-gold-500 hover:text-white transition-colors" data-id="element-155">
                <InstagramIcon className="w-5 h-5" data-id="element-156" />
              </a>
              <a href="#" aria-label="Follow us on Facebook" className="w-10 h-10 rounded-full bg-navy-800 flex items-center justify-center text-navy-300 hover:bg-gold-500 hover:text-white transition-colors" data-id="element-157">
                <FacebookIcon className="w-5 h-5" data-id="element-158" />
              </a>
            </div>
            <a href="mailto:info@brightstarsports.com" className="flex items-center text-navy-300 hover:text-gold-400 transition-colors text-sm" data-id="element-159">
              <MailIcon className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-160" />
              info@brightstarsports.com
            </a>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick Links" data-id="element-161">
            <h4 className="font-display font-bold text-lg mb-6 text-white" data-id="element-162">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-163">
              <li data-id="element-164">
                <Link to="/" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-165">
                  Home
                </Link>
              </li>
              <li data-id="element-166">
                <Link to="/about" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-167">
                  About Us
                </Link>
              </li>
              <li data-id="element-168">
                <Link to="/book" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-169">
                  Book a Session
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="/become-a-coach" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-171">
                  Become a Coach
                </Link>
              </li>
              <li data-id="element-172">
                <Link to="/medals" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-173">
                  Medals
                </Link>
              </li>
            </ul>
          </nav>

          {/* Activities */}
          <nav aria-label="Programmes" data-id="element-174">
            <h4 className="font-display font-bold text-lg mb-6 text-white" data-id="element-175">
              Programmes
            </h4>
            <ul className="space-y-4" data-id="element-176">
              <li data-id="element-177">
                <Link to="/badminton" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-178">
                  Badminton
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/activities/multi-sports" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-180">
                  Multi-Sports
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/activities/netball" className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-182">
                  Netball
                </Link>
              </li>
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Legal" data-id="element-183">
            <h4 className="font-display font-bold text-lg mb-6 text-white" data-id="element-184">
              Legal
            </h4>
            <ul className="space-y-4" data-id="element-185">
              <li data-id="element-186">
                <Link to="/legal" state={{
                tab: 'faq'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-187">
                  FAQ
                </Link>
              </li>
              <li data-id="element-188">
                <Link to="/legal" state={{
                tab: 'terms'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-189">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/legal" state={{
                tab: 'cookies'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-191">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-192">
                <Link to="/legal" state={{
                tab: 'privacy'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-193">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/legal" state={{
                tab: 'safeguarding'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-195">
                  Safeguarding Policy
                </Link>
              </li>
              <li data-id="element-196">
                <Link to="/legal" state={{
                tab: 'photo-consent'
              }} className="text-navy-300 hover:text-gold-400 transition-colors" data-id="element-197">
                  Photo &amp; Video Consent
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-navy-800 text-center text-sm text-navy-300" data-id="element-198">
          <p data-id="element-199">
            &copy; {new Date().getFullYear()} Bright Star Sports. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}